import React, { useState } from 'react';
import {
  Box,
  IconButton,
  styled,
  Tooltip,
  Typography,
} from '@material-ui/core';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';

export const FALLBACK_STRING = 'N/A';
interface InfoItemProps {
  title?: string;
  value?: string;
  withSecret?: boolean;
  withCopy?: boolean;
}

export const InfoItemTitle = styled(Typography)(({ theme }) => ({
  fontSize: 12,
  fontWeight: 600,
  textTransform: 'uppercase',
  color: theme.palette.text.secondary,
}));

const ValueBlock = ({
  value,
  handleCopy,
  showSecret = true,
}: {
  value: string;
  handleCopy?: () => void;
  showSecret?: boolean;
}) => (
  <Box display="flex" alignItems="center">
    <Typography
      component="code"
      variant="body1"
      color="textPrimary"
      onClick={handleCopy}
      role="button"
      style={{
        lineHeight: '28px',
        cursor: handleCopy ? 'pointer' : 'default',
        wordBreak: 'break-all',
        fontFamily: !showSecret ? 'monospace' : 'Open Sans',
      }}
    >
      {value}
    </Typography>
  </Box>
);

export const InfoItem = ({
  title,
  value = FALLBACK_STRING,
  withSecret = false,
  withCopy = false,
}: InfoItemProps) => {
  const [showSecret, setShowSecret] = useState(false);
  const [isCopied, setIsCopied] = useState(false);

  const handleCopy = () => {
    if (value || !isCopied) {
      navigator.clipboard.writeText(value);
      setIsCopied(true);
      setTimeout(() => setIsCopied(false), 1500);
    }
  };

  const getValue = () => {
    if (withSecret) {
      return showSecret ? value : '••••••••••••••••••••••••••••••••';
    }

    return value;
  };

  return (
    <Box>
      {title && <InfoItemTitle>{title}</InfoItemTitle>}
      {withCopy ? (
        <Tooltip title={isCopied ? 'Copied!' : 'Click to copy'}>
          <Box display="inline-flex" gridRowGap={8}>
            <ValueBlock
              value={getValue()}
              handleCopy={handleCopy}
              showSecret={showSecret}
            />

            {withSecret && (
              <IconButton
                size="small"
                style={{ marginLeft: 8 }}
                onClick={() => setShowSecret(prev => !prev)}
                aria-label={
                  showSecret ? 'Hide client secret' : 'Show client secret'
                }
              >
                {showSecret ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            )}
          </Box>
        </Tooltip>
      ) : (
        <ValueBlock value={getValue()} />
      )}
    </Box>
  );
};
